import { RightArrowIcon2 } from '@components/Icons/RightArrowIcon2';
import { SpeakerMuteIcon } from '@components/Icons/SpeakerMuteIcon';
import { useLowDataMode } from '@hooks/station';
import { useMusicState } from '@hooks/storeHooks/useMusicState';

const FEED_VIDEO_POSTER =
  'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/a479e0fc-0b01-4040-93cb-3dee3738544f/a479e0fc-0b01-4040-93cb-3dee3738544f.jpg';
const FEED_VIDEO_SRC =
  'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/a479e0fc-0b01-4040-93cb-3dee3738544f/a479e0fc-0b01-4040-93cb-3dee3738544f_mobile.mp4';

export const FeedLargeVideoPost = () => {
  const { setActivePlaylist } = useMusicState();
  const [isLowDataMode] = useLowDataMode();
  const album = {
    id: '9e74db17-d2cc-418b-a05c-232c22174512',
    upc: '666190400004',
    pk: '',
    albumName: 'The Blueprint',
    albumArtUrl:
      'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/a479e0fc-0b01-4040-93cb-3dee3738544f/albums/9e74db17-d2cc-418b-a05c-232c22174512/9e74db17-d2cc-418b-a05c-232c22174512.jpg',
    description:
      'Architectural hip-hop masterpiece with intricate wordplay and beats.',
    category: 'music',
    genre: [],
    tracks: [
      {
        id: '35eeffe6-765b-4543-8e7d-7f621e007617',
        name: 'Foundation of Flow',
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/a479e0fc-0b01-4040-93cb-3dee3738544f/albums/9e74db17-d2cc-418b-a05c-232c22174512/tracks/35eeffe6-765b-4543-8e7d-7f621e007617/35eeffe6-765b-4543-8e7d-7f621e007617.mp3',
        duration: 0,
      },
      {
        id: '096b381e-7844-4cc8-ba39-bd1df9a73451',
        name: 'Urban Echoes',
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/a479e0fc-0b01-4040-93cb-3dee3738544f/albums/9e74db17-d2cc-418b-a05c-232c22174512/tracks/096b381e-7844-4cc8-ba39-bd1df9a73451/096b381e-7844-4cc8-ba39-bd1df9a73451.mp3',
        duration: 0,
      },
      {
        id: '1de99f10-5692-4e3b-8716-8fc8cbd9d373',
        name: 'Mind Over Matter',
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/a479e0fc-0b01-4040-93cb-3dee3738544f/albums/9e74db17-d2cc-418b-a05c-232c22174512/tracks/1de99f10-5692-4e3b-8716-8fc8cbd9d373/1de99f10-5692-4e3b-8716-8fc8cbd9d373.mp3',
        duration: 0,
      },
      {
        id: 'a4f69342-f422-4f83-b106-aa2ebdc44cc7',
        name: "The Architect's Creed",
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/a479e0fc-0b01-4040-93cb-3dee3738544f/albums/9e74db17-d2cc-418b-a05c-232c22174512/tracks/a4f69342-f422-4f83-b106-aa2ebdc44cc7/a4f69342-f422-4f83-b106-aa2ebdc44cc7.mp3',
        duration: 0,
      },
      {
        id: 'c0293ad9-c0bc-4638-83cd-ad62f15a90e6',
        name: 'Streetlight Philosophies',
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/a479e0fc-0b01-4040-93cb-3dee3738544f/albums/9e74db17-d2cc-418b-a05c-232c22174512/tracks/c0293ad9-c0bc-4638-83cd-ad62f15a90e6/c0293ad9-c0bc-4638-83cd-ad62f15a90e6.mp3',
        duration: 0,
      },
      {
        id: '388b86d6-9fc9-4d36-98fe-3b3ecc4b1d7b',
        name: 'The Art of the Verse',
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/a479e0fc-0b01-4040-93cb-3dee3738544f/albums/9e74db17-d2cc-418b-a05c-232c22174512/tracks/388b86d6-9fc9-4d36-98fe-3b3ecc4b1d7b/388b86d6-9fc9-4d36-98fe-3b3ecc4b1d7b.mp3',
        duration: 0,
      },
      {
        id: 'ea2c662c-4448-4910-978e-2bcf2b7b4a2f',
        name: 'Resilience in Rhyme',
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/a479e0fc-0b01-4040-93cb-3dee3738544f/albums/9e74db17-d2cc-418b-a05c-232c22174512/tracks/ea2c662c-4448-4910-978e-2bcf2b7b4a2f/ea2c662c-4448-4910-978e-2bcf2b7b4a2f.mp3',
        duration: 0,
      },
      {
        id: '2e6f5308-7cab-45f4-9b08-e3ed126a78fe',
        name: 'Echoes of Change',
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/a479e0fc-0b01-4040-93cb-3dee3738544f/albums/9e74db17-d2cc-418b-a05c-232c22174512/tracks/2e6f5308-7cab-45f4-9b08-e3ed126a78fe/2e6f5308-7cab-45f4-9b08-e3ed126a78fe.mp3',
        duration: 0,
      },
      {
        id: '3808b072-331e-4e91-a879-e88e1d6034b6',
        name: 'Metropolis Melodies',
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/a479e0fc-0b01-4040-93cb-3dee3738544f/albums/9e74db17-d2cc-418b-a05c-232c22174512/tracks/3808b072-331e-4e91-a879-e88e1d6034b6/3808b072-331e-4e91-a879-e88e1d6034b6.mp3',
        duration: 0,
      },
      {
        id: '8b136dc8-0c21-491f-822d-4bf0b6a32d8d',
        name: 'Last Verse Standing',
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/a479e0fc-0b01-4040-93cb-3dee3738544f/albums/9e74db17-d2cc-418b-a05c-232c22174512/tracks/8b136dc8-0c21-491f-822d-4bf0b6a32d8d/8b136dc8-0c21-491f-822d-4bf0b6a32d8d.mp3',
        duration: 0,
      },
      {
        id: '4e4dc689-90e4-425e-b41d-b3f143a6afd7',
        name: 'Can I Kick It (Rhyme Cover)',
        url: 'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/a479e0fc-0b01-4040-93cb-3dee3738544f/albums/9e74db17-d2cc-418b-a05c-232c22174512/tracks/4e4dc689-90e4-425e-b41d-b3f143a6afd7/4e4dc689-90e4-425e-b41d-b3f143a6afd7.mp3',
        duration: 0,
      },
    ],
    contributors: [
      {
        id: 'a479e0fc-0b01-4040-93cb-3dee3738544f',
        givenName: 'Jamal Hayes',
        thumbnailUrl:
          'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/a479e0fc-0b01-4040-93cb-3dee3738544f/a479e0fc-0b01-4040-93cb-3dee3738544f.jpg',
        videoDesktopUrl:
          'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/a479e0fc-0b01-4040-93cb-3dee3738544f/a479e0fc-0b01-4040-93cb-3dee3738544f_desktop.mp4',
        videoMobileUrl:
          'https://napstermusicstoragedev.blob.core.windows.net/music/contributors/a479e0fc-0b01-4040-93cb-3dee3738544f/a479e0fc-0b01-4040-93cb-3dee3738544f_mobile.mp4',
      },
    ],
    likes: 1500,
    type: 'Album',
  };
  const playMusic = () => {
    const playlist = {
      currentIndex: 0,
      album: album,
    };
    setActivePlaylist(playlist);
  };
  return (
    <div className="w-full bg-[linear-gradient(180deg,rgba(244,46,255,0.1)_0%,rgba(244,46,255,0)_100%)] rounded-[16px] pb-[16px]">
      <div className="flex p-4 w-full gap-2 items-center">
        <div className="flex w-[36px] h-[36px]">
          <img
            className="w-full h-full object-fit-cover"
            src="https://napstermusicstoragedev.blob.core.windows.net/music/contributors/a479e0fc-0b01-4040-93cb-3dee3738544f/a479e0fc-0b01-4040-93cb-3dee3738544f.jpg"
            alt="User"
          />
        </div>
        <div className="flex flex-col flex-1">
          <div className="flex text-[14px] font-semibold leading-[130%] text-left text-white pb-[2px]">
            Jamal Hayes
          </div>
          <div className="flex gap-[5px] items-center">
            <div className="flex text-[12px] font-normal leading-[130%] text-left text-white/60 pb-[2px]">
              @jamal.hayes
            </div>
            <div className="flex text-[12px] font-normal leading-[130%] text-left text-white/60">
              • now
            </div>
            <div className="flex">
              <button className="text-[8px] font-normal leading-[130%] text-left text-white/60 border border-white/20 p-[3px] rounded-[4px]">
                track
              </button>
            </div>
          </div>
        </div>
        <div className="flex">{/* <OptionsIcon opacityValue={0.8} /> */}</div>
      </div>
      {/* <div className="w-full flex px-4 gap-[4px] flex-wrap pb-4">
                <button
                    className="bg-[rgba(252,252,252,0.1)] relative pl-[30px] pr-[6px] py-1 rounded-[5px] overflow-hidden flex gap-[12px] items-center text-[11px] font-normal leading-[130%] text-left text-white">
                    <img
                        className="w-[16px] h-[16px] object-fit-cover absolute left-[5px] top-[3px]"
                        src="/assets/images/logged_user.png"
                        alt="User"
                    />
                    Mac Miller
                </button>
                <button
                    className="bg-[rgba(252,252,252,0.1)] relative pl-[30px] pr-[6px] py-1 rounded-[5px] overflow-hidden flex gap-[12px] items-center text-[11px] font-normal leading-[130%] text-left text-white">
                    <img
                        className="w-[16px] h-[16px] object-fit-cover absolute left-[5px] top-[3px]"
                        src="/assets/images/logged_user.png"
                        alt="User"
                    />
                    Balloonerism
                </button>
                <button
                    className="bg-[rgba(252,252,252,0.1)] relative pl-[30px] pr-[6px] py-1 rounded-[5px] overflow-hidden flex gap-[12px] items-center text-[11px] font-normal leading-[130%] text-left text-white">
                    <img
                        className="w-[16px] h-[16px] object-fit-cover absolute left-[5px] top-[3px]"
                        src="/assets/images/logged_user.png"
                        alt=""
                    />
                    Pittsburgh
                </button>
            </div> */}

      <div className="flex w-full relative">
        <div className="absolute flex z-[102] right-[12px] top-[18px]">
          <button className="w-[40px] h-[40px] flex items-center justify-center bg-[rgba(0,0,0,0.2)] rounded-full ">
            <SpeakerMuteIcon />
          </button>
        </div>

        <div className="flex w-full rounded-b-[16px] filter drop-shadow-[0_0_64px_rgba(0,0,0,0.8)]">
          {isLowDataMode ? (
            <img
              className="h-full w-full object-cover"
              src={FEED_VIDEO_POSTER}
              alt=""
              aria-hidden
            />
          ) : (
            <video
              className="h-full w-full object-cover"
              src={FEED_VIDEO_SRC}
              poster={FEED_VIDEO_POSTER}
              muted
              autoPlay
              loop
              playsInline
              webkit-playsinline="true"
              preload="metadata"
              aria-label="Music"
              role="img"
              aria-hidden="true"
            />
          )}
        </div>
        <div className="flex pt-[96px] pb-[16px] bg-[linear-gradient(180deg,rgba(0,0,0,0)_0%,rgba(0,0,0,1)_65.87%)] w-full absolute bottom-0 z-[1] px-4 gap-[12px] items-center">
          <div className="flex">
            <div className="flex relative" onClick={playMusic}>
              <img
                className="w-[56px] h-[56px] object-fit-cover overflow-hiddden"
                src="https://napstermusicstoragedev.blob.core.windows.net/music/contributors/a479e0fc-0b01-4040-93cb-3dee3738544f/albums/9e74db17-d2cc-418b-a05c-232c22174512/9e74db17-d2cc-418b-a05c-232c22174512.jpg"
                alt=""
              />
              <div
                className="w-[40px] h-[40px] absolute flex items-center justify-center bg-[rgba(0,0,0,0.2)] top-0 bottom-0 left-0 right-0 m-auto"
                onClick={playMusic}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={34}
                  height={34}
                  viewBox="0 0 32 34"
                  fill="none">
                  <g filter="url(#filter0_d_6748_198)">
                    <path
                      d="M8.66675 23.3333L23.1001 15L8.66675 6.66666V23.3333Z"
                      fill="#FCFCFC"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_6748_198"
                      x="0.666748"
                      y="0.666656"
                      width="30.4333"
                      height="32.6667"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB">
                      <feFlood floodOpacity={0} result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy={2} />
                      <feGaussianBlur stdDeviation={4} />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_6748_198"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_6748_198"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
              </div>
            </div>
          </div>
          <div className="flex flex-col flex-1">
            <div className="flex text-sm font-bold leading-[130%] text-left text-white pb-1">
              The Blueprint
            </div>
            <div className="flex text-xs font-medium leading-[130%] text-left text-white/80">
              Jamal Hayes
            </div>
          </div>
          <div className="w-[40px] h-[40px] flex items-center justify-center bg-[rgba(0,0,0,0.2)] rounded-full">
            <RightArrowIcon2 />
          </div>
        </div>
      </div>

      {/* <div className="flex w-full gap-[4px] relative z-[1] pt-4 px-4">
        <button className="flex items-center gap-[4px] h-[28px] border-1 border-white/20 w-fit px-3 rounded-full">
          <FavoriteIcon width={16} height={16} fillOpacity={0.8} />
          <span className="text-[10px] font-normal leading-[140%] text-white text-left">
            4.1K
          </span>
        </button>

        <button className="flex items-center gap-[4px] h-[28px] border-1 border-white/20 w-fit px-3 rounded-full">
          <CommentIcon />

          <span className="text-[10px] font-normal leading-[140%] text-white text-left">
            4.1K
          </span>
        </button>

        <button className="flex items-center gap-[4px] h-[28px] border-1 border-white/20 w-fit px-3 rounded-full">
          <SavedIcon />
          <span className="text-[10px] font-normal leading-[140%] text-white text-left">
            4.1K
          </span>
        </button>
      </div> */}
    </div>
  );
};
